import { render, staticRenderFns } from "./NbaPositionOpti.vue?vue&type=template&id=dbadb21e&scoped=true"
import script from "./NbaPositionOpti.vue?vue&type=script&lang=js"
export * from "./NbaPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./NbaPositionOpti.vue?vue&type=style&index=0&id=dbadb21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbadb21e",
  null
  
)

export default component.exports